import { LogLevel } from '@azure/msal-browser';

// Firefox's redirect flow (including private/incognito mode) needs auth state
// mirrored into a cookie since sessionStorage isn't reliably shared there.
const isFirefox = window.navigator.userAgent.indexOf('Firefox') > 0;

// Config object to be passed to Msal on creation
export const msalConfig = {
	auth: {
		clientId: 'df586d80-eab6-43bb-b564-69de168dacc1',
		authority: 'https://login.microsoftonline.com/common',
		// redirectUri: 'http://localhost:3005/',
		redirectUri: 'https://eden.supremecomponents.com/',
		postLogoutRedirectUri: '/',
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: isFirefox,
		claimsBasedCachingEnabled: true,
	},
	system: {
		allowNativeBroker: false, // Disables WAM Broker
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
	scopes: ['User.Read'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
	graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
